




import Vue from "vue";

import moment from "moment-timezone";

import {
  ContextMenuItem,
  ContextMenuItems,
} from "@/api/Termine";
import { Transaktion } from "@/api/Abrechnung";

export type PopoverMode = "edit" | "move-previous" | "move-next" | "select-date";

export interface MenuItemSelected {
  sourceStudio: string;
  targetStudio: string;
}

export default Vue.extend({
  name: "MonatsuebersichtContextMenu",
  data() {
    return {
      contextMenuEntries: [] as ContextMenuItems,
    };
  },
  methods: {
    open(sourceStudio: string, targetStudios: string[]) {
      const fn = (targetStudio: string) => {
        return ((originalEvent: Event, item: ContextMenuItem) =>
          this.onSelectContextmenu(
            originalEvent,
            sourceStudio,
            targetStudio
          )).bind(this);
      };
      this.contextMenuEntries = [];

      // Kontextmenü eines Tagesabschlusses
      targetStudios.forEach(targetStudio => {
        this.contextMenuEntries.push(
          {
            label: `Einnahmen von ${sourceStudio} nach ${targetStudio} verschieben`,
            icon: "pi pi-fw pi-angle-double-right",
            command: fn(targetStudio),
            visible: true,
          });
        });

      const contextMenu: any = this.$refs.contextMenu;
      contextMenu.show(event);
    },

    // Auswahl eines Kontextmenü-Eintrags
    onSelectContextmenu(event: any, sourceStudio: string, targetStudio: string) {
      this.$emit("select", { sourceStudio, targetStudio } as MenuItemSelected);
    },
  },
});
